<h5 class="mt-2 mb-4 ms-2">Limite Adicional por Cestas para Operações de Repasse</h5>

<section class="pesquisa">
  <div class="container">
    <form class="mt-3 mx-auto">
      <div class="mb-2 row">
        <div class="col"></div>
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-light me-2"
            [disabled]="!ideTranche"
            (click)="limpar()">
            Limpar
          </button>

          <button
            type="button"
            class="btn btn-success no-margin"
            [disabled]="!ideTranche"
            (click)="buscarTodosPorTranche()">
            Pesquisar
          </button>
        </div>
      </div>

      <div class="mb-3 row">
        <div class="col">
          <h3>Pesquisa</h3>
        </div>

        <div class="col-auto" *ngIf="podeCadastrar" ngbDropdown>
          <button
            class="btn btn-primary no-margin"
            type="button"
            [disabled]="!ideTranche"
            ngbDropdownToggle
            ngbTooltip="Cadastrar ou editar limite adicional.">

            <i class="fa fa-clipboard"></i>
            Cadastrar/Editar Novo Limite Adicional
          </button>

          <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="navegarCadastrarLimite()">
              Cadastrar Limite Adicional
            </button>

            <button ngbDropdownItem (click)="navegarEditarLimite()">
              Editar Limite Adicional
            </button>
          </div>
        </div>

        <div class="col-auto" *ngIf="podeCadastrar" ngbDropdown>
          <button
            class="btn btn-primary no-margin"
            type="button"
            [disabled]="!ideTranche"
            ngbDropdownToggle
            ngbTooltip="Cadastrar ou editar limite por agente financeiro.">

            <i class="fa fa-clipboard"></i>
            Cadastrar/Editar Limite por AF
          </button>

          <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="navegarCadastrarLimitePorAgente()">
              Cadastrar Limite
            </button>

            <button ngbDropdownItem (click)="navegarEditarLimitePorAgente()">
              Editar Limite
            </button>
          </div>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col-md-5 bn-form-group">
        <label for="tranche">Cesta:</label>

        <select
          id="tranche"
          class="form-select"
          [(ngModel)]="ideTranche"
          (change)="buscaTranche()">

          <option [ngValue]="null"></option>

          <option
            [ngValue]="tranche.id"
            *ngFor="let tranche of tranches">

            {{ tranche.numeroTranche }}
            ({{ tranche.dataInicioContratacao | date:'dd/MM/yyyy' }})
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5 bn-form-group">
        <label for="agenteFinanceiro">Agente Financeiro:</label>

        <select
          id="agenteFinanceiro"
          class="form-select"
          [(ngModel)]="idAgenteFinanceiro"
          [disabled]="!ideTranche">

          <option [ngValue]="null">Todos</option>

          <option
            [ngValue]="af.id"
            *ngFor="let af of agentesFinanceiros">

            {{ af.descricao }}
          </option>
        </select>
      </div>

      <div class="col-md-5 bn-form-group">
        <label for="limiteAdicional">Limite Adicional:</label>

        <select
          id="limiteAdicional"
          class="form-select"
          [(ngModel)]="idLimiteAdicional"
          [disabled]="!ideTranche">

          <option [ngValue]="null">Todos</option>

          <option
            [ngValue]="la.id"
            *ngFor="let la of limitesAdicionaisOpcoes">

            {{ la.descricao }}
          </option>
        </select>
      </div>

      <div class="col-md-2 bn-form-group">
        <label for="codigoPrograma">Código Programa:</label>

        <input
          id="codigoPrograma"
          type="text"
          class="form-control"
          [(ngModel)]="codigoPrograma"
          maxlength="200"
          placeholder="Ex.: 011202, 458014"
          ngbTooltip="Informe um ou mais códigos separados por vírgula"
          [disabled]="!ideTranche">
      </div>
    </div>
  </div>
</section>

<app-limite-adicional-listagem
  [limitesAdicionais]="limitesAdicionais"
  [ideTranche]="ideTranche"
  [permissaoGestorEnvio]="podeCadastrar"
  [dataAtualizacao]="dataAtualizacaoListagem"
  *ngIf="pesquisado">
</app-limite-adicional-listagem>